import React from 'react';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';
import {
    RegularText,
} from 'src/common/refactoredComponents/dataTable/DataTable.styled';
import { AdjustmentProductContainer, Type } from './Adjustments.styled';
import { setItemsDataHandler } from 'src/utils/util';
import CfnLabel from 'src/common/components/orderDetails/bundleCards/CfnLabel';
import ItemDescriptionLabel from 'src/common/components/orderDetails/bundleCards/ItemDescriptionLabel';
import i18n from 'src/i18n.js';
 
const t = (key) => i18n.t(key);

const AdjustmentsProducts = ({
    adjustmentsProducts,
    handleSetItemClick,
}) => {
    const setItemHandler = (data, orderList) => {
        const setItemDetails = setItemsDataHandler(data, orderList);
        handleSetItemClick(setItemDetails);
    };
    let colData = [
        {
            field: 'cfn',
            header: 'Sets/Items',
            width: '75%',
        },
        {
            field: 'quantity',
            header: t('consignmentBilling.priceOverride.priceOverrideTable.qty'),
            width: '20%',
        },
    ];

    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {},
        };
        switch (column.field) {
            case 'cfn':
                extraProps.headerStyle = {
                    padding: '0px 0px 0px 10px',
                    width: '65%',
                    height: '42px',
                };
                extraProps.bodyStyle = {
                    width: '65%',
                    margin: '10px 0 0 0',
                    padding: '0px 0px 0px 10px',
                    height: '42px',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <AdjustmentProductContainer
                                margin={'10px 0 0 0'}
                                flexDirection={'column'}
                                justifyContent={'flex-start'}
                            >
                                <CfnLabel
                                    setItemHandler={setItemHandler}
                                    setDetailsData={rowData}
                                    cfn={rowData.cfn}
                                    isShowSetItemDetails={true}
                                    cursor={'pointer'}
                                    textAlign={'left'}
                                />

                                <ItemDescriptionLabel
                                    description={rowData.description}
                                    lineHeight={'19px'}
                                    letterSpacing={'-0.1px'}
                                    mobileFontSize={'13px'}
                                />
                            </AdjustmentProductContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'quantity':
                extraProps.headerStyle = {
                    width: '35%',
                    textAlign: 'right',
                    padding: '0 4% 0 0',
                    height: '42px',
                };
                extraProps.bodyStyle = {
                    width: '35%',
                    margin: '10px 0 0 0',
                    padding: '0px 10px 0px 0px',
                    height: '42px',
                };
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <AdjustmentProductContainer
                                justifyContent={'flex-end'}
                                margin={'10px 0 0 0'}
                                alignItems={'flex-start'}
                            >
                                {rowData?.quantity || rowData?.uom ? (
                                    <RegularText
                                        color={'#000000'}
                                        fontSize={'16px'}
                                        height="28px"
                                    >
                                        {rowData?.quantity
                                            ? `${rowData.quantity} x`
                                            : ''}{' '}
                                        <Type>
                                            {rowData?.uom
                                                ? `${rowData.uom}`
                                                : ''}
                                        </Type>
                                    </RegularText>
                                ) : null}
                            </AdjustmentProductContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    return (
        <>
            <Datatable
                id={'orders-orderDetails-billingSummary-adjustments'}
                backgroundColorOdd={'#F5F5F599'}
                backgroundColorEven={'#FFFFFF99'}
                resizableColumns
                columns={colData}
                data={adjustmentsProducts}
            />
        </>
    );
};

export default AdjustmentsProducts;
